
<div v-if="data" class="d-flex align-center">
  <!-- chip -->
  <div class="d-flex align-center justify-center"
    style="background-color: #EFF0F6; padding: 0px 10px 0px 6px"
    :style="{width: chipWidth, height: chipHeight, borderRadius: `calc(${chipHeight} / 2)`}"
  >
    <!-- File, Workflow, Re:D -->
    <div v-if="data?.category" class="d-flex align-center">
      <!-- File -->
      <div v-if="data?.category === 'file' && hasFile" class="d-flex align-center">
        <img :src="iconSrc" :style="{width: iconWidth, height: iconHeight}">
        <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #414458; margin-left: 2px">
          {{ displayLabel }}
        </div>
      </div>
      <!-- master -->
      <div v-else-if="data?.category === 'master'" class="d-flex align-center">
        <img src="/assets/data_icon/icon_master.svg" :style="{width: iconWidth, height: iconHeight}">
        <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #414458; margin-left: 2px">
          Table
        </div>
      </div>
      <!-- Workflow -->
      <div v-else-if="data?.category === 'rpa'" class="d-flex align-center">
        <img src="/assets/data_icon/icon_rpa2.svg" :style="{width: iconWidth, height: iconHeight}">
        <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #414458; margin-left: 2px">
          Workflow
        </div>
      </div>
      <!-- Re:D -->
      <div v-else class="d-flex align-center">
        <img src="/assets/data_icon/icon_recolumn2.svg" :style="{width: iconWidth, height: iconHeight}">
        <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #414458; margin-left: 2px">
          Re:D
        </div>
      </div>
    </div>
    <!-- Workflow (result_file) -->
    <div v-else-if="data?.data_type === 'result_file'" class="d-flex align-center">
      <img src="/assets/data_icon/icon_rpa2.svg" :style="{width: iconWidth, height: iconHeight}">
      <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #414458; margin-left: 2px">
        Workflow
      </div>
    </div>
    <!-- Re:D -->
    <div v-else class="d-flex align-center">
      <img src="/assets/data_icon/icon_recolumn2.svg" :style="{width: iconWidth, height: iconHeight}">
      <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #414458; margin-left: 2px">
        Re:D
      </div>
    </div>
  </div>
</div>
